export default {
  addToCart: {
    id: 'product_page_add_to_cart',
    defaultMessage: 'Add to cart',
  },
}
